export function toolIdToTranslatedKey(toolId) {
  const snakeCaseKeyToolId = toolId.replace(/[A-Z]/g, match => `_${match}`);
  const translationKey = `${snakeCaseKeyToolId.toUpperCase()}_TITLE`;
  return translationKey;
}
//# sourceMappingURL=toolIdToTranslatedKey.js.map